function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* istanbul ignore file */

/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { string } from 'prop-types';
import cn from 'classnames';
import styles from './footer.scss';
import SideDrawer from '../sideDrawer';
import WrapperTop from './WrapperTop';
import WrapperBottom from './WrapperBottom';
import NavLinks from './NavLinks';
import ContactUsContent from './ContactUsContent';
import ToggleEmployeesAndPartners from './ToggleEmployeesAndPartners';
import ToggleHospitalsAndMedicalGroups from './ToggleHospitalsAndMedicalGroups';
import { companyInformationArray, patientSelfServiceLinksArray, hospitalsAndMedicalGroupsArray, employeesAndPartnersArray } from './states';

var Footer = function Footer(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'footer' : _ref$className,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      restProps = _objectWithoutProperties(_ref, ["className", "dataAnalyticsId", "dataAnalyticsLabel"]);

  var _useState = useState(patientSelfServiceLinksArray),
      _useState2 = _slicedToArray(_useState, 1),
      patientSelfServiceLinks = _useState2[0];

  var _useState3 = useState(hospitalsAndMedicalGroupsArray),
      _useState4 = _slicedToArray(_useState3, 1),
      hospitalsAndMedicalGroups = _useState4[0];

  var _useState5 = useState(employeesAndPartnersArray),
      _useState6 = _slicedToArray(_useState5, 1),
      employeesAndPartners = _useState6[0];

  var _useState7 = useState(companyInformationArray),
      _useState8 = _slicedToArray(_useState7, 1),
      companyInformation = _useState8[0];

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var onChangeFunc = function onChangeFunc(event) {
    setInputValue(event.target.value);
  }; // if we have a default style to pass in


  var footerStyles = styles['footer-default'];

  var formatDate = function formatDate() {
    return new Date().getFullYear();
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(footerStyles, className),
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "sharp-footer"
  }, restProps), /*#__PURE__*/React.createElement(WrapperTop, {
    toggleEmployeesAndPartners: /*#__PURE__*/React.createElement(ToggleEmployeesAndPartners, null, /*#__PURE__*/React.createElement(React.Fragment, null, employeesAndPartners.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName,
        target: options.target
      });
    }))),
    toggleHospitalsAndMedicalGroups: /*#__PURE__*/React.createElement(ToggleHospitalsAndMedicalGroups, null, /*#__PURE__*/React.createElement(React.Fragment, null, hospitalsAndMedicalGroups.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName
      });
    }))),
    patientSelfServiceLinks: patientSelfServiceLinks.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName,
        target: options.target
      });
    }),
    hospitalsAndMedicalGroups: hospitalsAndMedicalGroups.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName,
        target: options.target
      });
    }),
    employeesAndPartners: employeesAndPartners.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName,
        target: options.target
      });
    }),
    companyInformation: /*#__PURE__*/React.createElement("ul", {
      className: "unordered-list",
      "data-test-id": "companyInformation"
    }, companyInformation.map(function (options) {
      return /*#__PURE__*/React.createElement(NavLinks, {
        key: options.id,
        href: options.href,
        linkName: options.linkName,
        anchorName: options.anchorName,
        target: options.target
      });
    })),
    sideDrawer: /*#__PURE__*/React.createElement(SideDrawer, {
      trigger: /*#__PURE__*/React.createElement("p", {
        className: "list-item contact-us"
      }, "Contact Us"),
      title: 'Contact Sharp Healthcare'
    }, /*#__PURE__*/React.createElement(ContactUsContent, {
      onChangeFunc: onChangeFunc,
      inputValue: inputValue
    }))
  }), /*#__PURE__*/React.createElement(WrapperBottom, {
    formatDate: formatDate()
  }));
};

Footer.propTypes = {
  className: string,
  dataAnalyticsLabel: string,
  dataAnalyticsId: string
};
export default Footer;